import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "cnpjCuit",
    standalone: false
})
export class CnpjCuitPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (!value) return value;

    // CNPJ
    // Example: 12.345.678/9123-45
    if (value.length == 14)
      return `${value.substring(0, 2)}.${value.substring(
        2,
        5
      )}.${value.substring(5, 8)}/${value.substring(8, 12)}-${value.substring(
        12
      )}`;

    // CUIT
    // Example: 12-34567891-2
    if (value.length == 11)
      return `${value.substring(0, 2)}-${value.substring(
        2,
        10
      )}-${value.substring(10)}`;

    return value;
  }
}
